import './styles.scss';

import { ReactElement } from 'react';

import { getClasses } from '@/utils';

export type SkyhopPdfHeaderProps = React.ComponentProps<'div'> & {
  height?: number;
  src?: string;
};

const SkyhopPdfHeader = ({ height = 56, src, children, ...props }: SkyhopPdfHeaderProps): ReactElement => (
  <div {...props} className={getClasses('SkyhopPdfHeader', props.className)}>
    <div className="SkyhopPdfHeader-Logo">
      <img
        alt="Skyhop Global"
        src={src || '/public/assets/images/Skyhop_global_logo.png'}
        style={{
          width: 'auto',
          height,
        }}
      />
    </div>
    <div className="SkyhopPdfHeader-Title">{children}</div>
  </div>
);

export default SkyhopPdfHeader;
